<template>
    <div class="aba-emrpesa">
        <container-loader v-if="isLoading && !$store.getters.isLoading" />
        <div class="vertical-flow">
            <div class="columns">
                <div
                    class="column"
                    :class="[
                        permissao.create &&
                        !assClienteIntegracao &&
                        permissaoUsuario.create &&
                        !clienteIntegracao
                            ? 'is-4'
                            : permissao.create &&
                              !assClienteIntegracao &&
                              (!permissaoUsuario.create || clienteIntegracao)
                            ? 'is-6'
                            : permissaoUsuario.create &&
                              !clienteIntegracao &&
                              (!permissao.create || assClienteIntegracao)
                            ? 'is-6'
                            : 'is-8',
                    ]"
                >
                    <search-bar
                        :onSearch="debouncedOnSearch"
                        tooltipLabel="msg-campo-busca-cliente"
                    />
                </div>

                <div
                    class="column situacao-select"
                    :class="[
                        permissao.create &&
                        !assClienteIntegracao &&
                        !clienteIntegracao &&
                        permissaoUsuario.create
                            ? 'is-2'
                            : permissao.create &&
                              !assClienteIntegracao &&
                              (!permissaoUsuario.create || clienteIntegracao)
                            ? 'is-3'
                            : permissaoUsuario.create &&
                              !clienteIntegracao &&
                              (!permissao.create || assClienteIntegracao)
                            ? 'is-3'
                            : 'is-4',
                    ]"
                >
                    <label v-text="$t('situacao')" />
                    <v-select
                        ref="situacaoInput"
                        class="is-100"
                        label="label"
                        :options="situacoes"
                        @input="onSituacaoChanged"
                        v-model="situacao"
                    >
                        <template slot="option" slot-scope="option">
                            {{ $t(option.label) }}
                        </template>
                        <template slot="selected-option" slot-scope="option">
                            {{ $t(option.label) }}
                        </template>
                        <template slot="no-options">{{ $t('sem-resultados') }}</template>
                    </v-select>
                </div>

                <div class="column is-3" v-if="!assClienteIntegracao && permissao.create">
                    <button
                        class="save-btn botao-acao"
                        type="button"
                        @click="showModalClientesNaoAssociados"
                    >
                        {{ $t('vincular-cliente') }}
                    </button>
                </div>

                <div
                    class="column is-3"
                    v-if="permissaoUsuario.create && !clienteIntegracao && permissao.create"
                >
                    <button
                        class="save-btn botao-acao"
                        type="button"
                        @click="
                            $router.push({
                                name: isPromotor
                                    ? 'clientes-new'
                                    : `${abrev}-cliente-dados-cadastrais-new`,
                                query: {
                                    tela: 'empresa-cliente',
                                    id: $route.params.id,
                                    name: $route.params.name,
                                    dadoscadastrais: $parent.abaSelecionada,
                                    politicacomercial: $route.query.politicacomercial
                                        ? $route.query.politicacomercial
                                        : null,
                                },
                            })
                        "
                    >
                        {{ $t('adicionar-cliente') }}
                    </button>
                </div>
            </div>

            <div class="registry-wrapper">
                <empty-table-message v-if="isEmpty" />
                <b-table
                    v-else
                    :data="assclienteempresa"
                    class="data-table"
                    @sort="sortTable"
                    backend-sorting
                >
                    <b-table-column
                        v-for="(f, i) in fields"
                        :key="i"
                        :field="f.key"
                        :label="f.key != 'excluir' ? $t(f.key) : ''"
                        :width="f.width"
                        :class="{
                            'excluir-field': f.key == 'excluir',
                        }"
                        :sortable="f.sortable"
                        :custom-sort="f.sortFn"
                    >
                        <template v-slot:header>
                            <span v-if="f.key == 'data-hora'">
                                {{ $t(f.key) }}
                                <b-icon
                                    class="m-0"
                                    icon="information"
                                    size="is-small"
                                    v-tippy
                                    :title="$t(`informacao-tooltip-${f.key}`)"
                                />
                            </span>
                        </template>

                        <template v-slot="props">
                            <div
                                v-if="
                                    f.key == 'idclienteerp' || f.key == 'nome' || f.key == 'rsocial'
                                "
                            >
                                <span>{{ props.row[f.key] }}</span>
                            </div>
                            <div v-else-if="f.key == 'excluir'">
                                <span v-if="permissao.update && !assClienteIntegracao">
                                    <b-button
                                        class="action-button"
                                        :type="
                                            props.row['replicapda'] == 3
                                                ? 'is-danger'
                                                : 'is-success'
                                        "
                                        :icon-right="
                                            props.row['replicapda'] == 3 ? 'delete' : 'check'
                                        "
                                        @click="promptChangeSituacao(props.row)"
                                        v-tippy
                                        :title="
                                            $t(
                                                props.row['replicapda'] == 3
                                                    ? 'desativar'
                                                    : 'reativar'
                                            )
                                        "
                                    />
                                </span>
                            </div>
                            <div v-else-if="f.key == 'replicapda'">
                                <b-tag
                                    class="table-tag table-tag-full-width"
                                    v-if="props.row['replicapda'] == 3"
                                    type="is-success"
                                    size="is-medium"
                                    >{{ $t('ativo') }}</b-tag
                                >
                                <b-tag
                                    class="table-tag table-tag-full-width"
                                    v-else
                                    type="is-danger"
                                    size="is-medium"
                                    >{{ $t('inativo') }}</b-tag
                                >
                            </div>
                            <div v-else-if="f.key == 'data-hora'">
                                {{ props.row[f.key] | moment('DD/MM/YYYY HH:mm:ss') }}
                            </div>
                            <div v-else>
                                {{ props.row[f.key] }}
                            </div>
                        </template>
                    </b-table-column>
                </b-table>
                <PaginationViewer
                    class="mb-0"
                    :resetPagination="pagination.resetPagination"
                    :totalItems="pagination.totalRows"
                    :perPageOptions="pagination.perPageOptions"
                    :optionStarted="pagination.optionStarted"
                    @change="updatePagination"
                />
            </div>

            <!-- MODAL DE ASSOCIACAO -->
            <b-modal :active.sync="showModalAssociacao">
                <div class="bg">
                    <ClienteModal :idempresa="$route.params.id" @fecharModal="fecharModal" />
                </div>
            </b-modal>
        </div>
    </div>
</template>

<script>
// SERVICES
import AssClienteEmpresa from '@/services/vendas/empresa/abas/AssClienteEmpresaService';
import ClienteModal from '../modal/ClienteModal.vue';

// COMPONENTS
import ContainerLoader from '@/components/content/loader/ContainerLoader';

export default {
    components: {
        ContainerLoader,
        ClienteModal,
    },
    data() {
        return {
            assClienteIntegracao: this.$store.state.user.tabelasERPWebServer.includes(
                'ASSCLIENTEEMPRESA'
            ),
            clienteIntegracao: this.$store.state.user.tabelasERPWebServer.includes('CLIENTE'),
            assclienteempresa: [],
            fields: [
                { key: 'idclienteerp', width: null, sortable: true, sortFn: null },
                { key: 'nome', width: null, sortable: true, sortFn: null },
                { key: 'rsocial', width: null, sortable: true, sortFn: null },
                { key: 'replicapda', width: 80, sortable: true, sortFn: null },
                { key: 'excluir', width: 20, sortable: false, sortFn: null },
            ],
            service: new AssClienteEmpresa(this.$http, this.$router),
            permissao: false,
            permissaoUsuario: false,
            pagination: {
                resetPagination: false,
                perPageOptions: [10, 25, 50, 100],
                optionStarted: 0,
                perPage: null,
                totalRows: 0,
                currentPage: 1,
            },
            situacao: { id: 4, label: 'todos' },
            situacoes: [
                { id: 4, label: 'todos' },
                { id: 3, label: 'ativos' },
                { id: 2, label: 'inativos' },
            ],
            isLoading: false,
            isEmpty: false,
            debouncedOnSearch: null,
            queryFilter: '',
            column: 'nome',
            order: 'asc',
            isSaving: false,
            delete: null,
            showModalAssociacao: false,

            abrev: this.$route.meta.contexto.slice(0, 3),
            isVenda: this.$route.meta.contexto == 'vendas',
            isPromotor: this.$route.meta.contexto == 'promotor',
            isAgro: this.$route.meta.contexto == 'agro',
        };
    },
    created() {
        this.pagination.perPage = this.pagination.perPageOptions[this.pagination.optionStarted];

        if (this.isVenda) {
            this.permissao = this.hasPermissionAccess(
                'vendas',
                'empresa',
                'ven-empresa-dados-cadastrais-cliente'
            );
        } else if (this.isPromotor) {
            this.permissao = this.hasPermissionAccess(
                'promotor',
                'empresa',
                'pro-empresa-dados-cadastrais-cliente'
            );
        } else if (this.isAgro) {
            this.abrev = this.$route.meta.contexto.slice(0, 4);
            this.permissao = this.hasPermissionAccess(
                'agro',
                'empresa',
                'agro-empresa-dados-cadastrais-clientes'
            );
        }

        this.permissaoUsuario = this.hasPermissionAccess(
            'admin',
            'gerenciar-usuarios',
            'admin-gerenciar-usuarios'
        );

        if (!this.permissao.read) {
            this.$router.push({
                name: 'acesso-nao-permitido',
                params: { tela: 'cliente' },
            });
        } else {
            this.debouncedOnSearch = this.debounce(this.onSearch, 500);
            this.carregarDados();
        }
    },
    methods: {
        carregarDados(currentPage = 1) {
            if (currentPage == 1 && this.pagination.currentPage != 1)
                this.pagination.resetPagination = true;

            this.isLoading = true;

            this.findAll(
                this.column,
                this.order,
                currentPage - 1,
                this.pagination.perPage,
                this.situacao.id,
                this.$route.params.id,
                this.queryFilter
            )
                .then(this.mapItems)
                .then((value) => {
                    this.assclienteempresa = value;
                    this.isEmpty = this.assclienteempresa.length <= 0;
                })
                .catch((e) => {
                    this.isEmpty = true;
                    this.$root.showMessage('error', 'msg-erro-load');
                    console.error('Erro ao carregar os clientes.');
                })
                .finally((_) => {
                    this.isLoading = false;
                    this.pagination.resetPagination = false;
                });
        },
        findAll(column, order, page, limit, situacao, idempresa, ...params) {
            if (this.isVenda) {
                return this.service.findAllVendas(
                    column,
                    order,
                    page,
                    limit,
                    situacao,
                    idempresa,
                    ...params
                );
            } else if (this.isPromotor) {
                return this.service.findAllPromotor(
                    column,
                    order,
                    page,
                    limit,
                    situacao,
                    idempresa,
                    ...params
                );
            } else {
                return this.service.findAllAgro(
                    column,
                    order,
                    page,
                    limit,
                    situacao,
                    idempresa,
                    ...params
                );
            }
        },
        mapItems(body) {
            this.pagination.totalRows = body.totalElements;
            if (this.isPromotor) {
                return body.content.map((m) => {
                    return {
                        idassclienteempresa: m.idassclienteempresa,
                        idclienteerp: m.procliente.idclienteerp,
                        nome: m.procliente.nome,
                        rsocial: m.procliente.rsocial,
                        'data-hora': m.datahorainc,
                        replicapda: m.replicapda,
                    };
                });
            } else {
                return body.content.map((m) => {
                    return {
                        idassclienteempresa: m.idassclienteempresa,
                        idclienteerp: m.cliente.idclienteerp,
                        nome: m.cliente.nome,
                        rsocial: m.cliente.rsocial,
                        'data-hora': m.datahorainc,
                        replicapda: m.replicapda,
                    };
                });
            }
        },
        updatePagination(value) {
            this.pagination.resetPagination = false;
            this.pagination.perPage = value.perPage;
            this.pagination.currentPage = value.currentPage;
            this.carregarDados(value.currentPage);
        },
        sortTable(field, order) {
            this.column = field;
            this.order = order;
            this.carregarDados(this.pagination.currentPage);
        },
        onSituacaoChanged(val) {
            this.situacao = val
                ? this.situacoes.filter((v) => v.id == val.id)[0]
                : this.situacoes[0];
            this.carregarDados();
        },
        onSearch(value) {
            this.queryFilter = this.removeAcentos(value.replace(/[./-]+/g, ''));
            this.pagination.currentPage = 1;
            this.carregarDados();
        },
        promptChangeSituacao(row) {
            this.delete = row;
            let message = this.$t(
                    row.replicapda == 3
                        ? 'msg-confirmacao-desativacao-n'
                        : 'msg-confirmacao-reativacao-n', 
                    { n: row.nome }
                );
            this.$root.confirm({
                message: message,
                onConfirm: this.updateSituacaoRegistro,
                onCancel: this.removePrompt,
            });
        },
        removePrompt() {
            this.delete = null;
        },
        updateSituacaoRegistro() {
            let tempFailure =
                this.delete.replicapda == 3
                    ? 'msg-erro-ao-reativar-associacao-cliente'
                    : 'msg-erro-ao-desativar-associacao-cliente';

            let tempAssclienteempresa = {
                idassclienteempresa: this.delete.idassclienteempresa,
                replicapda: this.delete.replicapda == 3 ? 2 : 3,
            };

            this.isLoading = true;

            this.updateSituacao(tempAssclienteempresa)
                .then((r) => {
                    if (r.status == 200) {
                        let tempSuccess =
                            r.content.replicapda == 3
                                ? 'msg-sucesso-ao-reativar-associacao-cliente'
                                : 'msg-sucesso-ao-desativar-associacao-cliente';
                        this.$root.showMessage('success', tempSuccess);
                        this.carregarDados(this.pagination.currentPage);
                    } else if (r.status == 500) {
                        this.$root.showMessage('error', 'Erro ao atualizar status.');
                    }
                })
                .catch((e) => {
                    console.error('Erro ao atualizar status.', e);
                    this.$root.showMessage('error', tempFailure);
                })
                .finally((_) => {
                    this.isLoading = false;
                    this.delete = null;
                });
        },
        updateSituacao(assclienteempresa) {
            if (this.isVenda) return this.service.updateSituacaoVendas(assclienteempresa);
            else if (this.isPromotor) return this.service.updateSituacaoPromotor(assclienteempresa);
            else return this.service.updateSituacaoAgro(assclienteempresa);
        },
        redirect(name) {
            setTimeout(() => {
                this.$router.push(
                    {
                        name: name,
                        query: {
                            tela: 'empresa-usuario',
                            id: this.$route.params.id,
                            name: $route.params.name,
                            dadoscadastrais: $parent.abaSelecionada,
                            politicacomercial: $route.query.politicacomercial
                                ? $route.query.politicacomercial
                                : null,
                        },
                        params: { name: this.$route.params.name },
                    },
                    1000
                );
            });
        },
        showModalClientesNaoAssociados() {
            this.showModalAssociacao = !this.showModalAssociacao;
        },
        fecharModal() {
            this.showModalAssociacao = false;
            this.carregarDados();
            this.$root.showMessage('success', 'msg-sucesso-ao-adicionar-associacao');
        },
    },
};
</script>

<style lang="scss" scoped>
.aba-emrpesa {
    height: 100%;

    .situacao-select {
        div {
            height: 40px;
        }
    }

    .botao-acao {
        margin-top: 24px;
        width: 100%;
        height: 40px;
    }

    @media (max-width: 760px) {
        .situacao-select {
            width: 100%;
            padding-bottom: 0.8rem;
        }

        .botao-acao {
            margin-top: 0;
        }
    }
}
</style>
